"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayloadDisassembler = void 0;
var subscribableStream_1 = require("../subscribableStream");
/**
 * Base class streaming payload disassembling.
 */
var PayloadDisassembler = /** @class */ (function () {
    /**
     * Initializes a new instance of the [PayloadDisassembler](xref:botframework-streaming.PayloadDisassembler) class.
     *
     * @param sender The [PayloadSender](xref:botframework-streaming.PayloadSender) used to send the disassembled payload chunks.
     * @param id The ID of this disassembler.
     */
    function PayloadDisassembler(sender, id) {
        this.sender = sender;
        this.id = id;
    }
    /**
     * Serializes the item into the [IStreamWrapper](xref:botframework-streaming.IStreamWrapper) that exposes the stream and length of the result.
     *
     * @param item The item to be serialized.
     * @returns The stream containing the serialized item and the length of the stream.
     */
    PayloadDisassembler.serialize = function (item) {
        var stream = new subscribableStream_1.SubscribableStream();
        stream.write(JSON.stringify(item));
        stream.end();
        return { stream: stream, streamLength: stream.length };
    };
    /**
     * Begins the process of disassembling a payload and sending the resulting chunks to the [PayloadSender](xref:botframework-streaming.PayloadSender) to dispatch over the transport.
     *
     * @returns A completed Promise after the disassembled payload has been sent.
     */
    PayloadDisassembler.prototype.disassemble = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, stream, streamLength;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getStream()];
                    case 1:
                        _a = _b.sent(), stream = _a.stream, streamLength = _a.streamLength;
                        this.stream = stream;
                        this.streamLength = streamLength;
                        return [2 /*return*/, this.send()];
                }
            });
        });
    };
    /**
     * Begins the process of disassembling a payload and signals the [PayloadSender](xref:botframework-streaming.PayloadSender).
     */
    PayloadDisassembler.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var header;
            return __generator(this, function (_a) {
                header = {
                    payloadType: this.payloadType,
                    payloadLength: this.streamLength,
                    id: this.id,
                    end: true,
                };
                this.sender.sendPayload(header, this.stream);
                return [2 /*return*/];
            });
        });
    };
    return PayloadDisassembler;
}());
exports.PayloadDisassembler = PayloadDisassembler;
//# sourceMappingURL=payloadDisassembler.js.map